module.exports = __webpack_public_path__ + "static/img/shenghuo.c8039b76.png";